export const STORE_FILTER_PROPERTIES = 'tickets: store_filter_properties';
export const STORE_SAVED_FILTERS = 'tickets: store_saved_filters';
export const SET_CURRENT_FILTERS = 'tickets: set_current_filters';
export const RESET_CURRENT_FILTERS = 'tickets: reset_current_filters';
export const ADD_SAVED_FILTER = 'tickets: add_saved_filter';
export const REMOVE_SAVED_FILTER = 'tickets: remove_saved_filter';
export const UPDATE_SAVED_FILTER = 'tickets: update_saved_filter';
